import Vue from "vue";
import Vuex from "vuex";
import process from "./modules/process";
import login from "./modules/login";
import student from "./modules/student"
import company from "./modules/company"
import log from "./modules/log"

Vue.use(Vuex);

export const store = new Vuex.Store({

    modules :{
        process,
        login,
        student,
        company,
        log,
    }

});

export default store


// WEBPACK FOOTER //
// ./src/store/store.js